/**
 * @generated SignedSource<<ceeb6f5e4b427372ff065770f4ebe4b2>>
 * @relayHash 836dbddf7a5a4130431fe57d1668810f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f584889675147c92a8c6b21b35e30385eed398c535f053812cf5ddcab0e1181

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSettingsWidgetConfigurationAppQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type HelpCenterSettingsWidgetConfigurationAppQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly widgets: ReadonlyArray<{
      readonly __typename: "CsmAiWidgetConfig";
      readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type HelpCenterSettingsWidgetConfigurationAppQuery = {
  response: HelpCenterSettingsWidgetConfigurationAppQuery$data;
  variables: HelpCenterSettingsWidgetConfigurationAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EMBED"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsWidgetConfigurationAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
                      }
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                  }
                ],
                "type": "HelpCenter"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsWidgetConfigurationAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "allowedDomains"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isAnonymousAccessEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "position"
                      },
                      {
                        "concreteType": "CsmAiWidgetBrandingTheme",
                        "kind": "LinkedField",
                        "name": "theme",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "colorVibeVariant"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "radius"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "space"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "chatColor"
                          },
                          {
                            "concreteType": "CsmAiWidgetBrandingAttribution",
                            "kind": "LinkedField",
                            "name": "attribution",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "text"
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              },
              (v5/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8f584889675147c92a8c6b21b35e30385eed398c535f053812cf5ddcab0e1181",
    "metadata": {},
    "name": "HelpCenterSettingsWidgetConfigurationAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5f26abeb786a2413d66be942121861de";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
